import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { OverviewContainer, OverviewHighlightText } from "../../CommonComponents/CommonViews";
export const ProjectTenantProjectTemplatesHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>Project templates define which variable values are required for each tenant connected to this project.</p>
            <br />
            <p>Project templates allow tenants to provide different variable values for each project/environment combination.</p>
            <br />
            <p>
                Learn more about&nbsp;
                <ExternalLink href="MultiTenantVariables">tenant-specific variables</ExternalLink>.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
